<nav class="navbar navbar-full navbar-expand-lg navbar-dark bg-dark">
  <div class="container footer">

    <a class="footer-logo" href="#"><img src="assets/images/logo-white.png" alt="FLHSMV Logo"></a>

    <ul class="footer-links">
      <li><a [href]="footerPrivacyStatementURL" target="_blank"><span>Privacy Statement</span></a></li>
      <li><a [href]="footerEmailNoticeURL"><span>Email Notice</span></a></li>
      <li><a [href]="footerDisclaimerURL"><span>Disclaimer</span></a></li>
      <li><a [href]="footerADAURL"><span>ADA Notice</span></a></li>
      <li><a [href]="footerContactURL"><span>Contact</span></a></li>
    </ul>
    <p class="copyright">© Copyright 2014 – 2022 Florida Department of Highway Safety and Motor Vehicle. All Rights Reserved.</p>

  </div>
</nav>
